// extracted by mini-css-extract-plugin
module.exports = {"admin":"adminUser_admin__ckKLm","imgBackground":"adminUser_imgBackground__3j8WD"};